<template>
  <div id="myPurchase">
    <!--导航栏-->
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      :fixed="true"
      :border="true"
      @click-left="onClickLeft"
      ><template #right>
        <div
          v-if="$route.meta.add"
          name="replay"
          size="18"
          @click="add"
          class="add"
        >
          新增
        </div>
        <van-icon v-else name="replay" size="18" @click="refresh" />
      </template>
    </van-nav-bar>
    <transition name="router-slider" mode="out-in">
      <router-view style="padding-top: 46px"></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return { title: "采购管理" };
  },
  created() {},
  watch: {
    $route: {
      handler(to, from) {
        this.title = to.meta.title;
        console.log(to, "to");
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    add() {
      // 订单 收货 退货
      this.$router.push({ path: "/purchase/query" });
    },
    refresh() {
      location.reload();
    },
    onClickLeft() {
      if (this.$route.path.includes("purchase/query")) {
        this.$router.push({ path: "/dashboard/home" });
        return;
      }
      if (this.$route.meta.prev) {
        this.$router.replace(this.$route.meta.prev);
        return;
      }
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="less">
.van-nav-bar--fixed {
  position: fixed !important;
  z-index: 1000;
}
</style>
